export default {
  data: [],
  isProcess: false,
}